import { useState } from 'react';

function useCarousel(sliderRef) {
    const [ currentSlide, setCurrentSlide ] = useState(0);

    function handleNext() {
        sliderRef.current.slickNext();
    }

    function handlePrev() {
        sliderRef.current.slickPrev();
    }

    function handleAfterChange(curr) {
        setCurrentSlide(curr)
    }

    return {
        handleNext,
        handlePrev,
        handleAfterChange,
        currentSlide
    };
}

export default useCarousel;
